import script from "./RegularView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularView.vue?vue&type=script&setup=true&lang=ts"

import "./RegularView.vue?vue&type=style&index=0&id=dd15a44a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd15a44a"]])

export default __exports__